import { recordFromSnapshot } from 'utils/firebaseUtils'
import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_HISTORY_ERROR = 'CREATE_HISTORY_ERROR'
export const CREATE_HISTORY_SUCCESS = 'CREATE_HISTORY_SUCCESS'
export const DELETE_HISTORY_ERROR = 'DELETE_HISTORY_ERROR'
export const DELETE_HISTORY_SUCCESS = 'DELETE_HISTORY_SUCCESS'
export const UPDATE_HISTORY_ERROR = 'UPDATE_HISTORY_ERROR'
export const UPDATE_HISTORY_SUCCESS = 'UPDATE_HISTORY_SUCCESS'
const HISTORY_REGISTERED = 'HISTORY_REGISTERED'

// ------------------------------------
// Actions
// ------------------------------------
export function addPaymentHistory(history, payment) {
  return (dispatch, getState) => {
    const { users, firebase, settings } = getState()
    const { currentDates } = settings
    const startDate = moment(currentDates.startDate)
    const fanout = {}
    const key = firebase
      .child(
        `history/${startDate.format('YYYY/MM/DD')}/${
          history.key
        }/transaction/payments/`
      )
      .push().key
    payment.createdBy = users.currentUser.key
    payment.createdAt = moment().format()
    payment.updatedBy = users.currentUser.key
    payment.updatedAt = moment().format()
    fanout[
      `history/${startDate.format('YYYY/MM/DD')}/${
        history.key
      }/transaction/payments/${key}`
    ] = payment
    return firebase.update(fanout, error => {
      if (error) {
        Rollbar.error(error)
      }
    })
  }
}
export function removePaymentHistory(history, payment) {
  return (dispatch, getState) => {
    const { users, firebase, settings } = getState()
    const { currentDates } = settings
    const startDate = moment(currentDates.startDate)
    firebase
      .child(
        `history/${startDate.format('YYYY/MM/DD')}/${
          history.key
        }/transaction/payments/${payment.key}/deletedBy`
      )
      .transaction(
        currentData => {
          return users.currentUser.key
        },
        (error, committed, snapshot) => {
          if (error) {
            Rollbar.error(error)
            return
          }
          const fanout = {
            [`history/${startDate.format('YYYY/MM/DD')}/${
              history.key
            }/transaction/payments/${payment.key}`]: null
          }
          return firebase.update(fanout, error => {
            if (error) {
              Rollbar.error(error)
            }
          })
        }
      )
  }
}
export function deleteTable(history) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('history/' + history.key).remove(error => {
      if (error) {
        console.error('ERROR @ createTABLE :', error)
        dispatch({
          type: DELETE_HISTORY_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateHistory(history, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()

    firebase.child('history/' + history.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateTable :', error)
        dispatch({
          type: UPDATE_HISTORY_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerHistoryListeners() {
  return (dispatch, getState) => {
    const { firebase, settings } = getState()
    const { currentDates } = settings
    const startDate = moment(currentDates.startDate)
    let nodeDate = moment()
    if (nodeDate.date() !== startDate.date() && nodeDate.isAfter(startDate)) {
      nodeDate.subtract(1, 'days')
    }
    const ref = firebase
      .child('history/' + startDate.format('YYYY/MM/DD'))
      .orderByChild('date')
    ref.on('child_added', snapshot =>
      dispatch({
        type: CREATE_HISTORY_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_changed', snapshot =>
      dispatch({
        type: UPDATE_HISTORY_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_HISTORY_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
    return dispatch({ type: HISTORY_REGISTERED })
  }
}

export const actions = {
  updateHistory,
  registerHistoryListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_HISTORY_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.today.slice()
    tmpList = tmpList.filter(history => history.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [action.payload, ...state.today]
    } else {
      list = [...state.today]
    }
    return Object.assign({}, state, { today: list })
  },
  [CREATE_HISTORY_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_HISTORY_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      today: state.today.map(history => {
        return history.key === action.payload.key ? action.payload : history
      })
    }),
  [UPDATE_HISTORY_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_HISTORY_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      today: (state.today || []).filter(history => {
        return history.key !== action.payload.key
      })
    }),
  [DELETE_HISTORY_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [HISTORY_REGISTERED]: (state, action) =>
    Object.assign({}, state, { registered: true })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { today: [], registered: false }
export default function historyReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/history.js